import React from "react";
import { Button, Text, Thumbnail, Icon } from "@shopify/polaris";
import { DeleteIcon } from "@shopify/polaris-icons";

export function SelectedResourceList({ items, onRemove, emptyLabel }) {
  if (!items.length) {
    return (
      <Text as="p" variant="bodySm" tone="subdued">
        {emptyLabel}
      </Text>
    );
  }

  return (
    <div className="fsb-placement-resource-scroll">
      <div className="fsb-placement-resource-rows">
        {items.map((item) => (
          <div key={item.id} className="fsb-placement-resource-row">
            <div className="fsb-placement-resource-row__thumb">
              <Thumbnail size="small" source={item.image || ""} alt={item.title || ""} />
            </div>
            <span className="fsb-placement-resource-row__title" title={item.title}>
              {item.title}
            </span>
            <button
              type="button"
              className="fsb-placement-resource-row__delete"
              aria-label={`Remove ${item.title}`}
              onClick={() => onRemove(item.id)}
            >
              <Icon source={DeleteIcon} tone="critical" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ResourcePickerBlock({ buttonLabel, onPick, items, onRemove, emptyLabel }) {
  return (
    <div className="fsb-placement-resource-panel">
      <Button onClick={onPick}>{buttonLabel}</Button>
      <SelectedResourceList items={items} onRemove={onRemove} emptyLabel={emptyLabel} />
    </div>
  );
}
